<div id="base-eAuthorization-page">
    <div class="row">
        <div id="align-icon">
            <div id="eAuth-icon-green">e</div>
        </div>
        <div id="align-header">
            <div id="eAuth-section-header">eAuthorization</div>
        </div>
    </div>
    <div *ngIf="!cannotDisplayAnyAccountHolders && !accountTypeIneligibleForEAuth; else mmIneligibleAccountPage" >
            <div id="eAuthorization-page">
                <div id="eauth-text">
                    Clients who may be eligible to use
                    <span id="eauth-tooltip">eAuthorization
                        <span id="eauth-tooltip-text">{{eAuthorizationTooltipText}}</span> 
                    </span>
                    are listed here. If their setup is complete, they're ready to eAuthorize transactions. If their email 
                    address is required, please submit their address and we'll send them instructions for setting up
                    <span id="eauth-tooltip">Schwab Alliance
                        <span id="eauth-tooltip-text">{{schwabAllianceTooltipText}}</span> 
                    </span>.
                </div>
                <mm-eauth-table
                    [showSubmitEmailAddressButton]="true"
                    [setupEAuthorizationSelected]="true">
                </mm-eauth-table>
            </div>
        </div>
    <ng-template #mmIneligibleAccountPage>
        <mm-ineligible-account [eAuthClientsResponse]="eauthClientsResponse" [isEAuth]="true" ></mm-ineligible-account>
    </ng-template>   
</div>